import axios from './axios';
import SETTINGS from '../settings'
import router from "@/router";
export default {
    getCompanies(cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/usercompanies`,).then(response => {
            console.log('User companies', response.data)
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    },
    getPublicCompanies(params, cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/companypublic`,).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    },
    getPublicCompany(params, cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/companyslug`, { params: params }).then(response => {
            cb(response.data)
        }).catch(e => {
            if (e.response.status === 404) {
                router.push('/login')
            }
            console.log(e)
        })
    },
    getCapgeminiCompany(slug, cb) {
        console.log('Slug', slug)
        axios.get(`${SETTINGS.API_BASE_PATH}/checkcompanyisopencapgemini/${slug}`,).then(response => {
            console.log('Check company is open capgemini', response.data)
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    }
}